import SortDirectionControl from './SortDirectionControl';
import React from 'react';
import { Popover, Button, Icon, Input, Checkbox } from 'antd';

export const Domain = ({ onChange, onChangeExact, exact, params }) => {
  const changeSort = () => {
    let order;

    if (params?.order === '') {
      order = 'asc';
    } else if (params?.order === 'asc') {
      order = 'desc';
    } else {
      order = '';
    }

    onChange({ ...params, order });
  };

  const content = (
    <>
      <div style={{ marginBottom: 8, display: 'flex', alignItems: 'center' }} onClick={changeSort}>
        <b style={{ marginRight: 5 }}>Sort:</b>
        <SortDirectionControl order={params?.order} />
      </div>

      <div style={{ marginBottom: 8 }}>
        <Checkbox
          checked={exact}
          onChange={(e) => {
            if (e.target.checked) {
              onChangeExact(true);
            } else {
              onChangeExact(false);
            }
          }}
        >
          Exact Search
        </Checkbox>
      </div>

      <Input
        value={params?.value}
        placeholder='Domain'
        style={{ width: '150px' }}
        onChange={(e) => {
          onChange({ ...params, value: e.target.value });
        }}
        allowClear
      ></Input>
    </>
  );

  return (
    <Popover content={content} title='Domain' trigger='click'>
      <Button className='sighting-filter' style={{ width: '18%' }}>
        Domain
        <Icon type='down' style={{ color: '#d9d9d9' }} />
      </Button>
    </Popover>
  );
};
